import {createSettingsParams, SettingsParamType} from '@wix/tpa-settings'

import {SettingsParamsType, TextAlignment} from '../../types/createStylesParams'
import {
  formSettingsParams,
  FormSettingsParams,
} from '../../components-shared/Settings/FormDesign/settingsParams'

import {displaySettingsParams, DisplaySettingsParams} from './Settings/Tabs/Display/settingsParams'
import {
  areasLayoutSettingsParams,
  AreasLayoutSettingsParams,
  layoutSettingsParams,
  LayoutSettingsParams,
} from './Settings/Tabs/Layout/settingsParams'
import {textsSettingsParams, TextsSettingsParams} from './Settings/Tabs/Texts/settingsParams'

enum AreasStyle {
  Cards = 'cards',
  Dropdown = 'dropdown',
}

type AreasSettingsParams = {
  showAreasDescription: SettingsParamType.Boolean
  areasStyle: SettingsParamType.String
  areasCardsAlignment: SettingsParamType.String
  areasTextAlignment: SettingsParamType.String
}

const areasSettingsParams = createSettingsParams<AreasSettingsParams>({
  showAreasDescription: {
    type: SettingsParamType.Boolean,
    getDefaultValue: () => true,
  },
  areasStyle: {
    type: SettingsParamType.String,
    getDefaultValue: () => AreasStyle.Cards,
  },
  areasCardsAlignment: {
    type: SettingsParamType.String,
    getDefaultValue: () => TextAlignment.Left,
  },
  areasTextAlignment: {
    type: SettingsParamType.String,
    getDefaultValue: () => TextAlignment.Left,
  },
})

export type SettingsParams = DisplaySettingsParams &
  AreasSettingsParams &
  FormSettingsParams &
  LayoutSettingsParams &
  AreasLayoutSettingsParams &
  TextsSettingsParams

export const settingsParams: SettingsParamsType<SettingsParams> = {
  ...displaySettingsParams,
  ...formSettingsParams,
  ...layoutSettingsParams,
  ...areasLayoutSettingsParams,
  ...textsSettingsParams,
}
export default settingsParams
